module.exports = __webpack_public_path__ + "img/sr-default.b4f298c8.png";